import { render, staticRenderFns } from "./notifications_another.vue?vue&type=template&id=ee0d7ae4&scoped=true"
import script from "./notifications_another.vue?vue&type=script&lang=js"
export * from "./notifications_another.vue?vue&type=script&lang=js"
import style0 from "./notifications_another.vue?vue&type=style&index=0&id=ee0d7ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0d7ae4",
  null
  
)

export default component.exports